import { Typography } from "@mui/material";
import React from "react";

export default function AboutPage() {
  return <Typography variant="h1">AboutPage</Typography>;
}
